import React from 'react';
import PropTypes from 'prop-types';
import {useTranslate} from '@computerrock/formation-i18n';
import {useStyles, Panel, DataRow, TextArea} from '@ace-de/ui-components';

const CostCoverageMedicinesNeededPanel = props => {
    const {cx} = useStyles();
    const {createTranslateShorthand} = useTranslate();
    const translateTab = createTranslateShorthand('sams_cost_coverage_tab');
    const {medicineName, onChangeHandler} = props;

    return (
        <Panel
            title={(
                <div
                    className={cx([
                        'global!ace-u-flex',
                        'global!ace-u-flex--grow-1',
                        'global!ace-u-flex--justify-space-between',
                    ])}
                >
                    <p>{translateTab('panel_title.medicines_needed')}</p>
                </div>
            )}
            qaIdent="sams-cost-coverage-medicines-needed"
        >
            <DataRow
                label={translateTab('data_row_label.medicine')}
                className={cx('ace-c-data-row--condensed')}
                qaIdent="sa-medicine-name"
            >
                <TextArea
                    className={cx('global!ace-u-flex--grow-1')}
                    isResizable={false}
                    value={medicineName}
                    onChange={value => onChangeHandler('medicineName', value)}
                />
            </DataRow>
        </Panel>
    );
};

CostCoverageMedicinesNeededPanel.propTypes = {
    medicineName: PropTypes.string,
    onChangeHandler: PropTypes.func.isRequired,
};

CostCoverageMedicinesNeededPanel.defaultProps = {
    medicineName: '',
};

export default CostCoverageMedicinesNeededPanel;
